export default "__VITE_ASSET__HeP0hInJ__"